import React, {useState, useEffect, useRef} from 'react'
import {  Grid, Button, Box, Typography, Card, MenuItem,
          Table, TableCell, TableContainer, TableRow, Menu,
          TableBody, TableHead,IconButton, Stack,Accordion,
          AccordionSummary, AccordionDetails, CardContent, TextField } from "@mui/material" ;
import { profileSettingStyles } from '../../../styles/materialComponent';
import { CssTextField} from '../../../styles/materialComponent';
import {useSelector, useDispatch} from "react-redux"
import {addClient,fetchClientType} from "../../../actions/client"
import { useNavigate, useLocation } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Phone from '../../../components/common/phone'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api'
import 'react-phone-input-2/lib/style.css'
import { validateUserType } from '../../../ValidateUserType';
import { fetchArbors } from '../../../actions/arboristLogin';

const clientContacts =[
  "Name",
  "Email",
  "Phone",
  "Actions"
]

const libraries = ['places'];

const AddClient = () => {
    const autocompleteRef = useRef(null)
    const location = useLocation()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const classes = profileSettingStyles()
    const [anchorEl, setAnchorEl] = useState(null);
    const [edit, setEdit]  = useState(false)
    const [error, setError] = useState('')
    const [selectedItemRow, setSelectedRow] = useState(null)
    const [open, setOpen] = useState(false)
    const {clientTypes} = useSelector(({client})=> client)
    const {arbors}=useSelector(({arbor})=>arbor)//for company
    const [clientData, setClientData] = useState({
      clientName:"",
      address:"",
      clientType:"",
      clientLat:"",
      clientLong:"",
      selectArbor:arbors?.length?arbors[0]._id:""
    })

    const [contact, setContact] = useState([])
    const [state, setState] = useState({
      name:  "",
      email: "",
      phone: "",
      countryCode: ""
    })

    const { isLoaded, loadError } = useJsApiLoader({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      libraries
  });

    const onLoadAutocomplete = (autocomplete) => {
      autocompleteRef.current = autocomplete;
  }
  const onPlaceChanged = () => {
    const  place  = autocompleteRef.current.getPlace();
    if(place) {
      const lat = place.geometry.location.lat()
      const lng = place.geometry.location.lng()
      setClientData({...clientData, address: place.formatted_address, clientLat:lat, clientLong:lng })
    }
  }
  

    useEffect(()=>{
      if(validateUserType()){
        dispatch(fetchArbors())
        dispatch(fetchClientType())
      }
      else{
        dispatch(fetchClientType())
      }
    },[])
  

    function handleClick(event, row) {
      setAnchorEl(event.currentTarget);
      setSelectedRow(row)
    }

    const handleContactSave = (e)=>{
      e.preventDefault()
      if(!error){
        if(edit){
          setContact(contact.map((item)=>{
            if(item.key === state.key){
              return {...item, name:state.name, email: state.email,
                phone: state.phone,
                countryCode: state.countryCode}
            }
            return item
          }))
          clear()
          setEdit(false)
        }else{
          const inputData =
          {
            key: new Date().getTime().toString(),
            name:state.name,
            email: state.email,
            phone: state.phone,
            countryCode: state.countryCode
            }
            setContact([...contact, inputData])
            clear()
        }
      }   
      }
    const clear =()=>{
      setState({
        name:"",
        email:"",
        phone:"",
        countryCode:""
      })
    }
    const handleChange =(e)=>{
      const {name, value} = e.target
      setClientData({...clientData, [name]:value})
    }

    function isValidEmail(email) {
      return /\S+@\S+\.\S+/.test(email);
    }

    const handleContactChange =(e)=>{
      const {name, value} = e.target
      if(name === "email"){
        if(!isValidEmail(e.target.value)){
          setError("email is not valid")
        }else{
          setError("")
        }
      }   
      setState({...state, [name]:value})
    }

    const handlePhoneInput = (v, code) => {
      setState({...state, phone:v, countryCode:code})
    };

    function handleCloses() {
      setAnchorEl(null);
      setSelectedRow(null)
    }

    const handleEdit = (row) => {
        const updatedItems = contact.map(item => {
          if (item.key === row.key) {
            setState(item)
            setEdit(true)
          }
          return item;
        });
        setContact(updatedItems);
      };

      const handleDelete =(index)=>{
      const updateList = contact.filter((elem)=>{
        return index!== elem.key
      })
      setContact(updateList)
    }
    const handleClose = () => {
      setOpen(false);
    };

    const handleSubmit =(e)=>{
      e.preventDefault()

      if(validateUserType() && !clientData.selectArbor){
        NotificationManager.error("All fields are required")
       }

      if(!clientData.clientName || !clientData.address || !clientData.clientType || !clientData.clientLat || !clientData.clientLong){
        NotificationManager.error("All fields are required")
      }else{
        const data = {
          clientName:clientData.clientName,
          address:clientData.address,
          clientType:clientData.clientType,
          clientLat:clientData.clientLat,
          clientLong: clientData.clientLong,
          contacts: contact,
        }
        if(validateUserType()){
          data.arborist=clientData.selectArbor
        }
        dispatch(addClient(data, navigate, location))
      }
    }

    const handleCancel=()=>{
      navigate(-1)
    }
    if (!isLoaded) {
      return <div>Loading...</div>;
    }
 
  return (
      <Grid container justifyContent="center">
      <Grid item xs={12} sm={12} md={8} lg={8}>
      <Card
        style={{boxShadow: "0 2px 4px 0 rgba(0,0,0,.2)", borderRadius:8, backgroundColor:"#FCFBFD"}}
      >
      <CardContent>
      <Box className={classes.profileText}>
        <Typography variant="h4" fontFamily="CormorantBoldItalic" style={{marginTop:50}}>Add Client</Typography>
      </Box>
        <Grid container spacing={3} style={{paddingTop:40, paddingBottom:80}}>

       {validateUserType() &&  <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          required
          select
          className={classes.textField1}
          variant="outlined"
          label="Select Arbor"
          name="slectArbor"
          value={clientData.selectArbor}
          onChange={(e)=>setClientData({...clientData,selectArbor:e.target.value})}
        >
          <MenuItem disabled value="">
            <em>None</em>
          </MenuItem>
          {arbors.length>0 && arbors.map((op)=>
          <MenuItem value={op._id}>{op.firstName}</MenuItem>
          )}
      </CssTextField>
      </Grid>}

       <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          className={classes.textField1}
          required
          variant="outlined"
          label="Client Name"
          name="clientName"
          value={clientData.firstName}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid} >
      <div className={classes.textField1} >
       <Autocomplete
          onLoad={onLoadAutocomplete}
          onPlaceChanged={onPlaceChanged}
        >
      <CssTextField
        style={{width:"100%"}}
        variant="outlined"
        label="Address"
        type='text'
        name="address"
        value={clientData.address}
        onChange={handleChange}
      />
      </Autocomplete>
      </div>
      </Grid>

        {/* <CssTextField
          required
          className={classes.textField1}
          variant="outlined"
          label="Address"
          name="address"
          value={clientData.address}
          onChange={handleChange}
        /> */}
      <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <CssTextField
          required
          select
          className={classes.textField1}
          variant="outlined"
          label="Client Type"
          name="clientType"
          value={clientData.clientType}
          onChange={handleChange}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {clientTypes?.length && clientTypes.map((op)=>
          <MenuItem value={op._id}>{op.name}</MenuItem>
          )}
      </CssTextField>
      </Grid>
      {
        contact?.length &&
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.grid}>
        <Card sx={{backgroundColor:"#FCFBFD"}}  className={classes.textField1}>
        <TableContainer>
        <Table aria-label="simple table">
        <TableHead >
          <TableRow>
        {
          clientContacts?.map((tab, index)=>
            <TableCell align="left" variant="h4">{tab}</TableCell>
          )
        }
            </TableRow>
            </TableHead>
            <TableBody>
            {contact?.length && contact?.map((row)=>
                <TableRow>
                <TableCell>
                  {row.name}
                </TableCell>
                <TableCell>
                  {row.email}
                  </TableCell>
                <TableCell>{row.phone}</TableCell>
                <TableCell>
                <Box>
                  <IconButton
                    aria-label="More"
                    aria-owns={open ? "long-menu" : undefined}
                    aria-haspopup="true"
                    onClick={(event)=>handleClick(event, row)}
                    style={{backgroundColor:"gray", color:"white", borderRadius:"4px", padding:7}}
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    open={Boolean(anchorEl && selectedItemRow === row)}
                    id="long-menu"
                    anchorEl={anchorEl}
                    onClose={handleCloses}
                  >
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleEdit(row)}>
                      <EditIcon /><Typography style={{marginLeft:5}}>Edit</Typography>
                      </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleClose} >
                      <IconButton onClick={()=>handleDelete(row.key)}>
                      <DeleteIcon /><Typography style={{marginLeft:5}}>Delete</Typography>
                        </IconButton>
                      </MenuItem>

                  </Menu>
              </Box>
                </TableCell>
            </TableRow>
              )}
            </TableBody>
            </Table>
            </TableContainer>
        </Card>
        </Grid>
      }
      <div className={classes.grid} style={{marginLeft:22, marginTop:20,}}>
      <Accordion className={classes.textField1} style={{ backgroundColor:"#FCFBFD"}}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
        <Typography style={{color:"rgba(0, 0, 0, 0.6)"}}> {edit ? "Edit Contact Details" : "Add Contact Details"} </Typography>
        </AccordionSummary>
        <AccordionDetails>
        <Grid container spacing={3} style={{padding:10}}>

              <Grid item xs={12} sm={12} md={12} lg={12} >
              <CssTextField
                fullWidth
                required
                variant="outlined"
                label="Name"
                name="name"
                value={state.name}
                onChange={handleContactChange}
              />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} >
              <CssTextField
                fullWidth
                required
                variant="outlined"
                label="Email"
                name="email"
                value={state.email}
                onChange={handleContactChange}
              />
              {error ? <div style={{color:"red"}}>{error}</div>: null}
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
              <Phone
                fullWidth
                required
                variant="outlined"
                label="Phone No"
                name="phone"
                value={state.phone}
                onChange={(v, code) => handlePhoneInput(v, code)}
                // onChange={(e)=>handleContactChange(e, index, "phone")}
              />
              </Grid>
             <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button
              style={{backgroundColor:(state.name && state.email && state.phone && !error) && "rgb(115 74 153)"}}
              fullWidth
              size="large"
              variant="contained"
              onClick={handleContactSave}
              disabled={state.name && state.email && state.phone && !error ? false : true }

            >
              Save
            </Button>
            </Grid>
             </Grid>
        </AccordionDetails>
      </Accordion>
       </div>
       <Grid item xs={12} sm={12} md={6} lg={6} className={classes.grid} style={{margin:"auto"}}>
      <Button
        className={classes.submitButton1}
        style={{backgroundColor:"rgb(115 74 153)"}}
        size="large"
        variant="contained"
        onClick={handleSubmit}
      >
        Add
      </Button>
      <Button
      // type="reset"
        sx={{ml:2}}
        className={classes.cancelButton1}
        style={{backgroundColor:"lightgray", color:"black"}}
        size="large"
        variant="contained"
        onClick={handleCancel}
      >
        Cancel
      </Button>
    </Grid>
      </Grid>
      </CardContent>
    </Card>
    </Grid>
    </Grid>

  )
}

export default AddClient